'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEmailCaptureResponseMessage = undefined;

var _messageTypes = require('../constants/messageTypes');

var _isType = require('./isType');

var isEmailCaptureResponseMessage = exports.isEmailCaptureResponseMessage = (0, _isType.isType)(_messageTypes.EMAIL_CAPTURE_RESPONSE);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/pubnub-message/operators/isEmailCaptureResponseMessage.js
// module id = 272
// module chunks = 2 3